import { DocsSearch } from 'components/docs/docs-search';

const DocsHero = ({ title, subtitle }: { title: string; subtitle: string }) => (
	<section className='hero-grid relative border-b py-12 sm:py-16'>
		<div className='relative z-1 mx-auto max-w-6xl px-5 sm:px-8'>
			<p className='type-pretitle mb-3'>Playbooks documentation</p>
			<h1 className='type-display max-w-3xl'>{title}</h1>
			<p className='mt-4 max-w-2xl text-base leading-7 text-foreground-body sm:text-lg'>{subtitle}</p>
			<div className='mt-7 max-w-xl'>
				<DocsSearch prominent />
			</div>
		</div>
	</section>
);

export { DocsHero };
